// errorTranslations.js

export const errorTranslations = {
    ' Invalid credentials': 'بيانات الاعتماد غير صحيحة',
  
  };
  